import React, { ReactElement } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { CONTINUE_COMMENT, CONTINUE_GUIDE_1, CONTINUE_GUIDE_2, CONTINUE_GUIDE_3 } from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';

function Continue({ data = {} }: { data: any }): ReactElement {
  const { patient } = data;
  const { formData, setFormData } = useReduxForm('survey');
  const { surveyType } = formData;

  return (
    <Layout>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{CONTINUE_COMMENT}</TypographyText>
        </Col>
      </Row>
      <Divider margin={11} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col style={{ width: '162px', height: '122.5px' }} yzTypeCol="center">
          <img alt="continueImg" src={`${process.env.PUBLIC_URL}/img/continue4x.webp`} width="162px" />
        </Col>
      </Row>
      <Divider margin={20} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{`${surveyType !== 'B2C' ? `${patient?.patientName}님, ` : ''}${CONTINUE_GUIDE_1}`}</TypographyText>
        </Col>
      </Row>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{CONTINUE_GUIDE_2}</TypographyText>
        </Col>
      </Row>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{CONTINUE_GUIDE_3}</TypographyText>
        </Col>
      </Row>
    </Layout>
  );
}

export default Continue;
